/**
 * Tratamento da lista de planos vinda da API.
 */

import type { Plan } from '../types/api';

/**
 * Frase que o ERP ainda devolve em alguns planos mas que o produto decidiu não
 * exibir. O legado removia a frase de `beneficios`, `detalhamento` e `ligacoes`
 * (ver `PlanoController::pegarPlanos`). Mantido idêntico.
 */
const PHRASE_TO_REMOVE = 'internet sem cortes';

function stripPhrase(value: string): string {
  const withoutPhrase = value.replace(new RegExp(PHRASE_TO_REMOVE, 'gi'), '');
  return withoutPhrase.replace(/\s+/g, ' ').trim();
}

/** Aplica o filtro "Internet sem cortes" em um plano, sem mutar o original. */
export function sanitizePlan(plan: Plan): Plan {
  const sanitized: Plan = { ...plan };

  if (Array.isArray(plan.beneficios)) {
    sanitized.beneficios = plan.beneficios.filter(
      (beneficio) => String(beneficio).trim().toLowerCase() !== PHRASE_TO_REMOVE
    );
  }

  if (typeof plan.detalhamento === 'string') {
    sanitized.detalhamento = stripPhrase(plan.detalhamento);
  }

  if (typeof plan.ligacoes === 'string') {
    sanitized.ligacoes = stripPhrase(plan.ligacoes);
  }

  return sanitized;
}

/** Aplica `sanitizePlan` na lista inteira. */
export function sanitizePlans(plans: Plan[]): Plan[] {
  return (plans || []).map(sanitizePlan);
}

/** Localiza um plano pelo id, aceitando id numérico ou string (vem da querystring). */
export function findPlan(plans: Plan[], id: number | string | null | undefined): Plan | null {
  if (id === null || id === undefined || id === '') return null;
  const target = String(id);
  return (plans || []).find((plan) => String(plan.id) === target) ?? null;
}
